import { useResize } from 'core/hooks/useResize';
import s from './Header.module.scss';
import { ButtonBlue } from '../Button/ButtonBlue';
import { Logo } from '../Logo';
import { ContentContainer } from '../ContentContainer';
import { ReactComponent as Users } from 'images/icons/users.svg';
import { ReactComponent as UserLogo } from 'images/icons/user.svg';
import { ReactComponent as Exit } from 'images/icons/exit.svg';

interface IHeaderProps {
	className?: string;
	isAuth: boolean; // test
}

export const Header = ({ className, isAuth }: IHeaderProps) => {
	const { windowWidth, isDesktop, isPhone } = useResize();
	// const { isAuth } = useAuth();

	return (
		<ContentContainer>
			<header className={`${s.header} ${className}`}>
				<Logo />

				{/* {isDesktop &&
					(isAuth ? (
						<div className={s.userInfo}>
							<div>
								<UserLogo />
								<span>example@mail.com</span>
							</div>

							<button>
								<Exit />
								<span>Выйти</span>
							</button>
						</div>
					) : (
						<ButtonBlue children={'Оставить заявку'} />
					))}

				{isPhone &&
					(isAuth ? (
						<div className={s.userInfo}>
							<button>
								<Exit />
							</button>
						</div>
					) : (
						<ButtonBlue
							className={s.btnMobile}
							children={
								<div>
									<Users />
								</div>
							}
						/>
					))} */}
			</header>
		</ContentContainer>
	);
};
